export const DATE_FORMAT = 'dd/MM/yyyy'
export const DATE_DAY_MONTH_FORMAT = 'dd/MM'
export const DATE_DAY_MONTH_SHORT_FORMAT = 'd MMM'
export const TIME_FORMAT = 'HH:mm'
export const DATE_TIME_FORMAT = 'dd/MM/yyyy HH:mm'
export const DATE_TIME_OFFSET_FORMAT = 'dd/MM/yyyy HH:mm z'
export const DATE_ABBREVIATED_FORMAT = 'E dd MMM yy'
export const DATE_TIME_SECONDS_FORMAT = 'dd/MM/yyyy HH:mm:ss'
export const ISO_8601_DATE_FORMAT = 'yyyy-MM-dd'
export const TIME_DATE_FORMAT = 'HH:mm, dd.MM.yyyy'
export const DAY_MONTH_TIME_FORMAT = 'dd MMM, HH:mm'
